import React, { useState, useEffect, useCallback } from "react";
import { FaEye, FaUpload, FaSyncAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../css/others/Table.css";
import Pagination from "../Reusablecomponents/Pagination";
import "../css/others/Popup.css";
import { apiCall } from "../main/ApiCall";
import axios from "axios";
import ToastPopup from "../popups/ToastPopup";
import { Job, createToastMessage, ToastMessage } from "../interFaces/interfaces";
import EncryptionUtils from "../main/encryptionUtils";
const BulkUpload: React.FC = () => {
  const [jobs, setJobs] = useState<Job[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [totalElements, setTotalElements] = useState<number>(0);
  const totalPages = Math.ceil(totalElements / itemsPerPage);
  const [file, setFile] = useState<File | null>(null);
  const [, setUploadError] = useState<string>("");
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const [fields, setFields] = useState<any>({});
  const [hasValidMappings, setHasValidMappings] = useState<boolean>(false);
  const navigate = useNavigate();
  const clientId = localStorage.getItem("clientId");
  const checkMappings = useCallback(async () => {
    try {
      if (!clientId) return;
      const response = await apiCall("get", "/api/client-mappings", null, { clientId });
      const hasMappings = Object.keys(response?.mappedData || {}).length > 0;
      const hasRawData = Object.keys(response?.rawData || {}).length > 0;
      const isValid = hasMappings && hasRawData;
      setHasValidMappings(isValid);
      if (!isValid) {
        setMessage(createToastMessage("Please complete fields mapping before data upload", "warning", 3000));
      }
    } catch (error) {
      setHasValidMappings(false);
      setMessage(createToastMessage("Please complete fields mapping before data upload", "warning", 3000));
    }
  }, [clientId]);
  const fetchJobs = useCallback(async () => {
    try {
      if (!clientId) return;
      const response = await apiCall("get", `/api/bulk-upload/job-master/paginated?page=${currentPage - 1}&size=${itemsPerPage}&clientId=${clientId}`);
      setJobs(response.content || []);
      setTotalElements(response.totalElements || 0);
    } catch (error) {
      console.error("Error fetching jobs:", error);
    }
  }, [clientId, currentPage, itemsPerPage]);
  useEffect(() => {
    const permissions = EncryptionUtils.get<any>("permissions", null);
    if (permissions?.tabs?.bulkUpload) {
      setFields(permissions.tabs.bulkUpload.fields);
    }
    checkMappings();
  }, [checkMappings]);
  useEffect(() => {
    fetchJobs();
  }, [fetchJobs]);
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
      setUploadError("");
    }
  };
  const handleBulkUpload = async () => {
    if (!file) {
      setUploadError("Please choose a file before uploading.");
      return;
    }
    if (!clientId) return;
    try {
      const presignedUrl = await apiCall("get", "/api/bulk-upload/s3presigneduploadurl", null, { fileName: file.name, action: "bulk_upload" });
      await axios.put(presignedUrl, file, {headers: { "Content-Type": file.type }});
      const urlObj = new URL(presignedUrl);
      const fileKey = decodeURIComponent(urlObj.pathname.substring(1));
      await apiCall("post", "/api/bulk-upload/complete", { clientId, fileKey });
      await apiCall("get", "/api/bulk-upload/process-messages");
      setMessage(createToastMessage("File processed successfully, go to BUILD FORMULA for further proceedings!", "success", 3000));
      setFile(null);
      setTimeout(() => window.location.reload(), 3000);
      fetchJobs();
    } catch (error: any) {
      setMessage(createToastMessage(error?.response?.data?.message || "Upload failed", "error", 3000));
    }
  };
  const handleViewJobDetails = (jobId: number) => { navigate(`/bulkuploaddetails/${jobId}`); };
  const handleRefresh = async (jobId: number) => {
    try {
      await apiCall("get", "/api/bulk-upload/job-details", null, { jobId });
      setMessage(createToastMessage("Job details refreshed successfully!", "success", 3000));
      setTimeout(() => window.location.reload(), 3000);
    } catch (error: any) {
      setMessage(createToastMessage(error?.response?.data?.message, "error", 3000));
    }
  };
  const handleViewMappedHeaders = () => { navigate("/mappedheaders") };
  const handleDocumentOpen = () => {
    const fileInput = document.getElementById("file-upload") as HTMLInputElement;
    fileInput?.click();
  };
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Project Data Upload</h2>
        <div className="table-title-actions">
          {fields.upload && hasValidMappings && (
            <>
              <button type="button" className={`bulk-upload-button ${file ? "disabled" : ""}`} onClick={handleDocumentOpen} disabled={!!file}>📁 Choose File</button>
              <input id="file-upload" type="file" accept=".csv, .xlsx, .json" onChange={handleFileChange} className="hidden-input" />
            </>
          )}
          {file && (
            <button onClick={handleBulkUpload} className="bulk-upload-button"><FaUpload />Bulk Upload</button>
          )}
          {fields.view && (
            <button onClick={handleViewMappedHeaders} className="view">Mapped Headers</button>
          )}
        </div>
      </div>
      <div className="table-container">
        <div className="table-inner-container">
          <table className="main-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Status</th>
                <th>File Type</th>
                <th>Error Message</th>
                <th>Created By</th>
                <th>Created On</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {jobs.length > 0 ? (
                jobs.map((job, index) => (
                  <tr key={job.jobId}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{job.jobStatus || "N/A"}</td>
                    <td>{job.importFileType || "N/A"}</td>
                    <td>{job.errorMessage || "N/A"}</td>
                    <td>{job.createdBy || "N/A"}</td>
                    <td>{job.ingestionTime || "N/A"}</td>
                    <td className="center">
                      {fields.view && job.jobStatus !== "PENDING" && (
                        <button onClick={() => handleViewJobDetails(job.jobId)} className="action-button"><FaEye /></button>
                      )}
                      {fields.create && (
                        <button onClick={() => handleRefresh(job.jobId)} className={`action-button ${job.jobStatus === "COMPLETED" ? "disabled" : ""}`} disabled={job.jobStatus === "COMPLETED"}><FaSyncAlt /></button>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7} className="no-data">No jobs available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage}/>
      {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
    </div>
  );
};
export default BulkUpload;